module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content"
  }, [_c('custom-toolbar', {
    attrs: {
      "backLabel": "Retour"
    }
  }, [_vm._v(_vm._s(_vm.$t("Parrainage")))]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', [_c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Titre")))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-ons-select', {
    staticClass: "select",
    attrs: {
      "modifier": "material",
      "required": ""
    },
    model: {
      value: (_vm.friend.pro_fk_genre),
      callback: function($$v) {
        _vm.$set(_vm.friend, "pro_fk_genre", $$v)
      },
      expression: "friend.pro_fk_genre"
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("Monsieur")))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("Madame")))])])], 1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Prénom de l'ami")))]), _vm._v(" "), _c('v-ons-input', {
    attrs: {
      "type": "text",
      "modifier": "material",
      "required": ""
    },
    model: {
      value: (_vm.friend.pro_fName),
      callback: function($$v) {
        _vm.$set(_vm.friend, "pro_fName", $$v)
      },
      expression: "friend.pro_fName"
    }
  })], 1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Nom de l'ami")))]), _vm._v(" "), _c('v-ons-input', {
    attrs: {
      "type": "text",
      "modifier": "material",
      "required": ""
    },
    model: {
      value: (_vm.friend.pro_lName),
      callback: function($$v) {
        _vm.$set(_vm.friend, "pro_lName", $$v)
      },
      expression: "friend.pro_lName"
    }
  })], 1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Email de l'ami")))]), _vm._v(" "), _c('v-ons-input', {
    attrs: {
      "type": "email",
      "modifier": "material",
      "required": ""
    },
    model: {
      value: (_vm.friend.pro_email),
      callback: function($$v) {
        _vm.$set(_vm.friend, "pro_email", $$v)
      },
      expression: "friend.pro_email"
    }
  })], 1), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.$t("Téléphone de l'ami")))]), _vm._v(" "), _c('v-ons-input', {
    attrs: {
      "type": "text",
      "modifier": "material",
      "required": ""
    },
    model: {
      value: (_vm.friend.pro_tel),
      callback: function($$v) {
        _vm.$set(_vm.friend, "pro_tel", $$v)
      },
      expression: "friend.pro_tel"
    }
  })], 1), _vm._v(" "), _c('v-ons-button', {
    on: {
      "click": _vm.sponsor
    }
  }, [_vm._v(_vm._s(_vm.$t("Envoyer")))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da3c5a6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SponsorshipForm.vue
// module id = 238
// module chunks = 0